const PRESETS = [
  { label: '7 days', days: 7 },
  { label: '30 days', days: 30 },
  { label: '90 days', days: 90 },
];

function fmt(date) {
  return date.toISOString().slice(0, 10);
}

export function rangeForDays(days) {
  const to = new Date();
  const from = new Date();
  from.setDate(from.getDate() - (days - 1));
  return { from: fmt(from), to: fmt(to) };
}

export default function DateRangePicker({ from, to, activeDays, onChange }) {
  return (
    <div className="date-range-picker">
      <div className="date-range-picker__presets">
        {PRESETS.map((p) => (
          <button
            key={p.days}
            className={`chip${activeDays === p.days ? ' chip--active' : ''}`}
            onClick={() => onChange({ ...rangeForDays(p.days), days: p.days })}
          >
            {p.label}
          </button>
        ))}
      </div>
      <div className="date-range-picker__custom">
        <input
          type="date"
          value={from}
          max={to}
          onChange={(e) => onChange({ from: e.target.value, to, days: null })}
        />
        <span className="date-range-picker__sep">&ndash;</span>
        <input
          type="date"
          value={to}
          min={from}
          max={fmt(new Date())}
          onChange={(e) => onChange({ from, to: e.target.value, days: null })}
        />
      </div>
    </div>
  );
}
